export type FaqEntry = {
  question: string;
  answer: string;
};

// Single source for the on-page FAQ accordion and the FAQPage JSON-LD in
// app/kahoot-alternative/page.tsx. Plain strings so both stay in sync.
export const faqEntries: FaqEntry[] = [
  {
    question: 'Is QuizWhizzer free?',
    answer:
      'Yes. The free plan includes unlimited quizzes, games of up to 30 players, and every question type, with no credit card required.',
  },
  {
    question: 'How much does QuizWhizzer Pro cost?',
    answer:
      'Pro is $59 a year, and that is the whole pricing page. It raises the player cap to 100 per game and unlocks unlimited quizzes, custom game boards, and images and audio in your questions.',
  },
  {
    question: 'Can I bring my Kahoot quizzes over?',
    answer:
      'Yes. Paste a link to any of your public kahoots and QuizWhizzer rebuilds it as a quiz in seconds, with questions, answers, and timings included. Question images are not carried over, since Kahoot licenses its image library for its own platform, so you add your own images after importing.',
  },
  {
    question: 'Do students need accounts?',
    answer:
      'No. Students open the play page in any browser, enter the game code, pick an avatar, and play. Phones, tablets, and laptops all work, with nothing to install.',
  },
  {
    question: 'How does the race actually work?',
    answer:
      'You pick a game board or upload your own image and draw a path across it. Correct answers move each student along the path, and powerups like freeze, teleport, and shield let players further back change the order. First across the finish line wins.',
  },
  {
    question: 'Can I use it for homework, not just live games?',
    answer:
      'Yes. Assign any quiz as homework with a deadline, or share it in practice mode for self-paced review. Post-game reports show every student and every answer either way.',
  },
];
